import React, { useState, useEffect } from "react";
import {
  useNegotiationChatApiQuery,
  useNegotiationAccRejMutation,
  useNegotiationCreatedMutation,
} from "features/Procurement/common/ProcurementApiSlice";
import { Spinner } from "react-bootstrap";
import { Label } from "reactstrap";
import Button from "@mui/material/Button";
import { toast } from "react-toastify";
import { selectCurrentRoles } from "features/auth/authSlice";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import Skeleton from "react-loading-skeleton";
export default function NegotiateWithSeller({
  negotiationItem,
  user_id,
  BuyersList,
  UserType,
  refetch,
  setNegotiationView,
  setInterestedBuyerModal,
  setNegotiationModal,
  queryId,query,
  // showFields, setShowFields,
  negotiatioanValues, setNegotiationValue,refetchBuyers
}) {
  const id = negotiationItem?.id;
  console.log("id getting", negotiationItem);
  const {
    data: getNegotiationChat,
    isLoading,
    refetch: refetchChat,
  } = useNegotiationChatApiQuery({ id: id, user_id: queryId });
  const [acceptNegotiation] = useNegotiationAccRejMutation();
  const [negotiationCreated] = useNegotiationCreatedMutation();
  const [loading, setLoading] = useState(false);
  const [negotiationStatus, setNegotiationStatus] = useState("");
   console.log("negotiatioanValues",negotiatioanValues)
  // const [negotiatioanValues, setNegotiationValue] = useState({
  //   price: negotiationItem?.price,
  //   quantity: negotiationItem?.quantity,
  //   procurement: negotiationItem?.id,
  //   message: "",
  //   send_to:
  //     UserType === "Buyer" && negotiationItem?.is_initial_relationship
  //       ? negotiationItem?.created_for_id
  //       : UserType === "Seller"
  //       ? negotiationItem.created_by
  //       : queryId,
  // });
  const [chatHistory, setChatHistory] = useState([]);
  const [showFields, setShowFields] = useState(false);
  const [loadingAccepted, setLoadingAccepted] = useState(false);
  useEffect(()=>{
  setNegotiationValue({
    price: negotiationItem?.price,
    quantity: negotiationItem?.quantity,
    procurement: negotiationItem?.id,
    message: "",
    send_to:
      UserType === "Buyer" && negotiationItem?.is_initial_relationship
        ? negotiationItem?.created_for_id
        : UserType === "Seller"
        ? negotiationItem.created_by
        : queryId,
  });
  },[negotiationItem])
  useEffect(() => {
    if (getNegotiationChat) {
      setChatHistory(getNegotiationChat?.data);
      if (getNegotiationChat?.data && getNegotiationChat?.data.length > 0) {
        const lastValue =
          getNegotiationChat?.data[getNegotiationChat?.data.length - 1];
        setNegotiationValue({
          price: lastValue?.price,
          quantity: lastValue?.quantity,
          procurement: negotiationItem?.id,
          message: "",
          send_to:
            UserType === "Buyer" && negotiationItem?.is_initial_relationship
              ? negotiationItem?.created_for_id
              : UserType === "Seller"
              ? negotiationItem.created_by
              : queryId,
        });
      }
    }
  }, [getNegotiationChat, refetchChat]);

  const handleAccepted = (val) => {
    setNegotiationStatus(val);
    // Show a confirmation dialog using SweetAlert
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${
        val === "Accepted" || val === "Negotiation Accepted"
          ? "Accept"
          : "Reject"
      } this Deal at price ${negotiatioanValues.price} for quantity ${
        negotiatioanValues.quantity
      }?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        let payload;
        if(UserType==="Buyer" && !negotiationItem?.is_initial_relationship){
          payload = {
            status: val,
            entity_type: UserType,
            user_id: user_id,
            final_quantity: negotiatioanValues.quantity,
            final_price: negotiatioanValues.price,
            seller_id:queryId
          };
        }
        else{
         payload = {
          status: val,
          entity_type: UserType,
          user_id: user_id,
          final_quantity: negotiatioanValues.quantity,
          final_price: negotiatioanValues.price,
        };
      }
        let id = negotiationItem?.id;
        acceptNegotiation({ id, payload })
          .unwrap()
          .then(async (data) => {
            toast.success(`Trade ${val} Successfully`);
            await refetch();
            // setNegotiationModal(false);
            refetchBuyers()
            setLoadingAccepted(false);
            setNegotiationView(null);
            setInterestedBuyerModal(false);
            setNegotiationModal(false);
          })
          .catch((error) => {
            toast.error(error?.data?.message);
            setLoadingAccepted(false);
          });
      } else {
        // User clicked 'No' or closed the dialog
      }
    });
  };

  const handleChange = (e) => {
    setNegotiationValue({
      ...negotiatioanValues,
      [e.target.name]: e.target.value,
    });
  };
  const handleOk = (e) => {
    e.preventDefault();
    if (negotiationItem?.minimum_quantity !== 0) {
      if (negotiatioanValues.quantity < negotiationItem?.minimum_quantity) {
        Swal.fire({
          title: `Negotiation Quantity cannot be less then Minimum Quantity`,
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancel",
          confirmButtonIcon: "fas fa-arrow-right",
        });
        return;
      }
    }

    setLoading(true);
    let payload = {
      ...negotiatioanValues,
      send_from: user_id,
      entity_type: UserType,
    };
    negotiationCreated(payload)
      .unwrap()
      .then((data) => {
        toast.success(`Trade Negotiated Successfully`);
        refetchChat();
        //   setNegotiationModal(false)
        refetch();
        refetchBuyers()
        setNegotiationView(null);
        setLoading(false);
        setInterestedBuyerModal(false);
        setNegotiationModal(false);
      })
      .catch((error) => {
        toast.error(error?.data?.message);
        setLoading(false);
        return;
      });
  };
  const handleRefetchChat = () => {
    refetchChat();
  };
  return (
    <div>
      <button onClick={() => handleRefetchChat()} style={{ float: "right" }}>
        <FontAwesomeIcon icon={faRotateLeft} />
      </button>
      <section class="msger ">
        {isLoading?<Skeleton count={7}/>
        :chatHistory.length > 0 ? (
          <div className="heightChat">
            {chatHistory?.map((data, index) => {
              return (
                <main class="msger-chat">
                  {data.entity_type === UserType ? (
                    <div class="msg right-msg">
                      <div
                        class="msg-img"
                        style={{
                          backgroundImage:
                            "url(https://image.flaticon.com/icons/svg/145/145867.svg)",
                        }}
                      ></div>
                      <div class="msg-bubble">
                        <div class="msg-info">
                          <div class="msg-info-name text-primary">
                            {UserType === "Buyer"
                              ? negotiationItem.buyer_name
                              : negotiationItem.seller_name}
                          </div>
                        </div>
                        <div class="msg-info">
                          <div class="msg-info-time">
                            <b>Price/Unit : ₹ {data.price}</b>
                          </div>
                          <div class="msg-info-time mx-3">
                            <b>
                              Qty : {data.quantity}{" "}
                              {negotiationItem.unit_of_measure}
                            </b>
                          </div>
                        </div>
                        <div class="msg-text">{data.message}</div>
                        <div class="msg-info">
                          <div
                            class="msg-info-name text-primary "
                            style={{ visibility: "hidden" }}
                          >
                            {data.entity_type}
                          </div>
                          <div class="msg-info-time text-gray mt-1">
                            {data.created_at.slice(0, 10)}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div class="msg left-msg">
                      <div
                        class="msg-img"
                        style={{
                          backgroundImage:
                            "url(https://image.flaticon.com/icons/svg/327/327779.svg)",
                        }}
                      ></div>

                      <div class="msg-bubble">
                        <div class="msg-info">
                          <div class="msg-info-name text-primary">
                            {UserType === "Buyer"
                              ? negotiationItem.seller_name
                              : negotiationItem.buyer_name}
                          </div>
                        </div>

                        <div class="msg-info">
                          <div class="msg-info-time">
                            <b>Price/Unit : ₹ {data.price}</b>
                          </div>
                          <div class="msg-info-time mx-3">
                            <b>
                              Qty : {data.quantity}{" "}
                              {negotiationItem.unit_of_measure}
                            </b>
                          </div>
                        </div>
                        <div class="msg-text">{data.message}</div>
                        <div class="msg-info">
                          <div
                            class="msg-info-name text-primary "
                            style={{ visibility: "hidden" }}>
                            {data.entity_type}
                          </div>
                          <div class="msg-info-time text-gray mt-1">
                            {data.created_at.slice(0, 10)}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </main>
              );
            })}
          </div>
        ) : (
          ""
        )}
        {query?.status==="Negotiation Rejected"? <div>
            <hr />
            <h5 className="mb-4">
              <div className="msg-info mx-3">
                <div className="checkingcss">{query?.status}</div>
              </div>
            </h5>
          </div>
        :negotiationItem?.negotiation_detail?.is_expired ? (
          <div>
            <hr />
            <h5 className="mb-4">
              <div className="msg-info mx-3">
                <div className="checkingcss">Negotiation Expired.</div>
              </div>
            </h5>
          </div>
        ) : (
          <>
            {negotiationItem?.is_seller_agreed ||
            negotiationItem?.status === "Rejected" ||
            negotiationItem?.status === "Negotiation Rejected" ||
            negotiationItem?.status === "Closed" ? (
              <div>
                <hr/>
                {query?.user_id!==negotiationItem?.created_for_id?
                 <h5 className="mb-4">
                 <div className="msg-info mx-3">
                   <div>
                     <span
                       className={
                         query?.status === "Closed"
                           ? "checkingcss"
                           : "text-successs"
                       }>
                       {query?.status} 
                     </span>
                    
                   </div>
                   <div className=""> </div>
                 </div>
               </h5>
               :
                <h5 className="mb-4">
                  <div className="msg-info mx-3">
                    <div>
                      <span
                        className={
                          negotiationItem?.status === "Rejected"
                            ? "checkingcss"
                            : "text-successs"
                        }>
                        {negotiationItem?.status}
                      </span>
                      &nbsp;at ₹ {negotiatioanValues?.price} for quantity
                      {negotiatioanValues?.quantity}
                      {BuyersList?.unit_of_measure} .
                    </div>
                    <div className=""> </div>
                  </div>
                </h5>
                       }
              </div>
            ) : (
              <form onSubmit={handleOk}>
                <div className="row mt-3">
                  {showFields ? (
                    <>
                      <div className="col-lg-5 form-group mb-2 text_box mx-3">
                        <Label className="f_p text_c f_400">
                          Quantity ({negotiationItem?.unit_of_measure})
                          <small className="text-danger">*</small>
                        </Label>
                        <input
                          name="quantity"
                          type="number"
                          className="msger-inputText "
                          value={negotiatioanValues?.quantity}
                          placeholder="Enter Quantity"
                          style={{
                            border: "2px solid #807474",
                            textIndent: "15px",
                            fontSize: "14px",
                            backgroundColor: "white",
                          }}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-lg-5 form-group mb-2 text_box mx-3">
                        <Label className="f_p text_c f_400">
                          Price/Unit (₹){" "}
                          <small className="text-danger">*</small>
                        </Label>
                        <input
                          name="price"
                          type="number"
                          value={negotiatioanValues.price}
                          className="msger-inputText"
                          style={{
                            border: "2px solid grey",
                            textIndent: "15px",
                            fontSize: "14px",
                            backgroundColor: "white",
                          }}
                          placeholder="Enter Price"
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <h6 className="mx-4 mt-1">
                        Total Price : ₹{" "}
                        {negotiatioanValues.quantity * negotiatioanValues.price}
                      </h6>
                      <div className="col-lg-12 form-group mb-2 text_box mt-2">
                        <div className="msger-inputarea">
                          <input
                            type="text"
                            className="msger-input"
                            placeholder="Enter your message..."
                            onChange={handleChange}
                            name="message"
                          />
                          <button className="msger-send-btn" type="submit">
                            OK {loading ? <Spinner size="sm" /> : ""}
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  <div className="text-center mt-2 mb-4">
                    {showFields ? (
                      ""
                    ) : (
                      <>
                        {UserType === "Buyer" ? (
                          ""
                        ) : (
                          <Button
                            variant="contained"
                            color="success"
                            size="small"
                            onClick={() =>
                              handleAccepted(
                                UserType === "Seller"
                                  ? "Negotiation Accepted"
                                  : "Accepted"
                              )
                            }
                            className="mx-2"
                          >
                            Accept&nbsp;
                            {loadingAccepted ? <Spinner size="sm" /> : ""}
                          </Button>
                        )}
                        <Button
                          variant="contained"
                          color="error"
                          size="small"
                          onClick={() => handleAccepted("Negotiation Rejected")}
                          className="mx-2"
                        >
                          Reject
                        </Button>
                      </>
                    )}
                    {showFields ? (
                      ""
                    ) : UserType === "Buyer" ? (
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => setShowFields(true)}
                      >
                        Negotiate
                      </Button>
                    ) : UserType === "Seller" &&
                      negotiationItem?.has_started_negotiation ? (
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => setShowFields(true)}
                      >
                        Negotiate
                      </Button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </form>
            )}
          </>
        )}
      </section>
    </div>
  );
}
